import { Test } from '@/api/tests';
import TestAssignWizard from '@/components/assignments/TestAssignWizard';
import { useModalContext } from '@/components/ui/modal-provider';
import { Patient } from '@/types/patient';

interface Props {
    test: Test;
    preSelectedPatient?: Patient;
}

export default function SendTestDialog({ test, preSelectedPatient }: Props) {
    const { closeModal } = useModalContext();
    return (
        <TestAssignWizard
            test={test}
            preSelectedPatient={preSelectedPatient}
            onClose={closeModal}
        />
    );
}
